module.exports = __webpack_public_path__ + "static/article-image-eb15b160ccd38a7c3953c5eaae145152.png";